module.exports = __webpack_public_path__ + "lock-v2y.svg";